import React from 'react';

const StaticFeedbackPage = () => {
  const feedbackData = {
    consentStatus: true, // or false based on your scenario
    questions: [
      { question: '1. Richtige Verdachtsdiagnose:', answer: 'Ja' },
      { question: '2. Richtige Rettungsdienstbehandlung:', answer: 'Nein', explanation: 'Behandlung nicht vollständig durchgeführt.' },
      { question: '3. Richtige Notfallmedikation:', answer: 'Ja' },
      { question: '4. Richtige Übergabe:', answer: 'Nein', explanation: 'Übergabe erfolgte ohne vollständige Akten.' },
      { question: '5. Zuweisung des Patienten:', answer: 'Stationär' },
      { question: '6. Richtige Priorisierung:', answer: 'Ja' },
      { question: '7. Patient hat sich innerklinisch verbessert:', answer: 'Ja' },
      { question: '8. Patient hat die Gesundheitskrise überwunden:', answer: 'Nein', explanation: 'Patient zeigt weiterhin Symptome.' },
      { question: '9. Innerklinische Reanimation:', answer: 'Nein' },
      { question: '10. Klinische Diagnose:', answer: 'Ja' },
    ],
    notes: 'Insgesamt zufriedenstellender Verlauf, jedoch Potenzial zur Optimierung in Übergabe und Nachsorgeprozessen.'
  };

  return (
    <div className="static-container" style={{ userSelect: 'none', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>Feedback über den Rettungsdienst (Statische Ansicht)</h2>
      <h3 style={{ color: feedbackData.consentStatus ? 'green' : 'red' }}>
        {feedbackData.consentStatus ? 'Der Patient hat eingewilligt' : 'Patientenzustimmung ausstehend'}
      </h3>
      <div style={{ marginTop: '20px' }}>
        {feedbackData.questions.map((item, index) => (
          <div key={index} style={{ marginBottom: '15px' }}>
            <label style={{ fontWeight: 'bold' }}>{item.question}</label>
            <p style={{ margin: '5px 0' }}>{item.answer}</p>
            {item.explanation && (
              <p style={{ fontStyle: 'italic', color: 'gray', marginLeft: '15px' }}>
                {item.explanation}
              </p>
            )}
          </div>
        ))}
        <div style={{ marginTop: '20px' }}>
          <label style={{ fontWeight: 'bold' }}>Bemerkungen:</label>
          <p style={{ marginTop: '5px' }}>{feedbackData.notes}</p>
        </div>
      </div>
    </div>
  );
};

export default StaticFeedbackPage;
